$(function ($) {
    var doAnimations = function () {
        var offset = $(window).scrollTop() + $(window).height(),
            $animatables = $('.animatable');

        $animatables.each(function (i) {
            var $animatable = $(this);

            if ($animatable.offset().top + $animatable.height() + 50 < offset) {
                if (!$animatable.hasClass('animate-in')) {
                    $animatable
                        .removeClass('animate-out')
                        .css('top', $animatable.css('top'))
                        .addClass('animate-in');
                }
            } else if (
                $animatable.offset().top + $animatable.height() + 50 >
                offset
            ) {
                if ($animatable.hasClass('animate-in')) {
                    $animatable
                        .removeClass('animate-in')
                        .css('top', $animatable.css('top'))
                        .addClass('animate-out');
                }
            }
        });
    };

    $(window).on('scroll', doAnimations);
    $(window).trigger('scroll');
});

$(document).ready(function () {
    // Pause just a moment
    setTimeout(function () {
        var $book = $('.book');

        // Apply the intro classes that will
        // appear to turn the book,
        // revealing its spine
        $book.addClass('bookIntro');

        // pause another moment, then turn back
        setTimeout(function () {
            $book.removeClass('bookIntro');
        }, 2000);
    }, 1000);
});
